<template>
    <div>
        <!-- <input type="file" accept=".xlsx" @change="handleFileChange" /> -->
        <section id="month-schedule-table" class="emp-tbl-data-sec">
            <table v-if="newFormattedSchedulerData.length" id="ns-ms-table-sch" class="monthly-sch-tbl w-full">
                <tr v-for="(emp, empIndex) in newFormattedSchedulerData" :key="'emp'+emp.id+empIndex">
                    <!-- Left side employee details section -->
                    <td class="month-td-left">
                        <el-popover
                            placement="top-start"
                            :title="emp.full_name"
                            trigger="hover"
                            :content="emp.designation_info.name">
                                <div slot="reference" class="month-td-data-left px-2 py-1 left-tbl-col border border-gray-900">
                                        <div class="flex items-center justify-between">
                                            <span class="text-ellipsis-style text-xs font-bold"> {{ emp.full_name }} </span>
                                            <img src="../../../../assets/icons/delete_icon-2.png" class="cursor-pointer" width="15px" @click="deleteShiftByEmp(emp.id)" />
                                        </div>
                                        <div class="text-green font-normal" style="font-size: 10px;">{{ emp.designation_info.name }}</div>
                                </div>
                            </el-popover>
                    </td>
                    <!-- Right side shift data section -->
                    <td v-for="(shift, shift_index) in emp.all_shift_data" :key="shift.uId"
                        :style="{ 'width': ((100 - 14) / emp.all_shift_data.length) + '%' }"
                        class="text-center month-td-right" style="padding-left: 4px;"> 
                        <div v-if="emp.all_shift_data.length" :ref="emp.id+ '-' +shift_index" class="month-td-data-right-shift border border-gray-900"
                            :class="[shift.leave_assigned ? 'empOnLeave' : '' , isCopyPaste ? 'cursor-pointer' : '']" >
                            <el-popover  v-if="(new Date(shift.date) > new Date('2022/12/12')) && !isCopyPaste" placement="bottom"
                                :width="shift.leave_assigned ? 40 : 250"  trigger="click">
                                <template>
                                    <!-- For shift select Dropdown -->
                                    <div v-if="!shift.leave_assigned">
                                        <span class="flex items-center justify-between mb-2">
                                            <el-tag  class="text-sm action-btn-for-sch"  :class="[(shift.shift_name || shift.week_off_assigned) ? 'cursor-pointer' : 'cursor-not-allowed']" 
                                                type="info" 
                                                @click="(shift.shift_name || shift.week_off_assigned) ? ($emit('saveSelectedShift', emp.id, shift, selected_sId, 'clear_shift'), togglePopover('close')) : ''">
                                                {{shift.week_off_assigned ? 'Clear Week Off' : 'Clear Shift'}}
                                            </el-tag>
                                            <el-tag type="danger" class="cursor-pointer text-sm" @click="togglePopover('close'), $emit('saveSelectedShift', emp.id, shift, true, 'leave')">Leave</el-tag>
                                        </span>

                                        <el-select v-model="selected_sId" filterable
                                            placeholder="Select shift" @change.self="togglePopover('close'),$emit('saveSelectedShift', emp.id, shift, selected_sId, 'shift')">
                                            <el-option v-for="item in shiftFieldDropDown" :key="item.id"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>

                                    <!-- For leave -->
                                    <div v-else style="width: 20px;">
                                        <img src="../../../../assets/images/delete-icon.png"
                                        style="width: 18px; color: #e29d5a; cursor: pointer; margin-top: 15px;"
                                        title="Delete" class="delete-icon"
                                        @click="togglePopover('close'), $emit('saveSelectedShift', emp.id, shift, selected_sId, 'clear_shift') ">
                                    </div>
                                </template>
                                <span slot="reference" class="cursor-pointer shift-data-cell" @click="shift.toggle_dropdown = true">
                                    <span v-if="shift.shift_name || shift.leave_assigned || shift.week_off_assigned"
                                        class="text-xs font-bold">
                                        {{ (shift.leave_assigned) ? 'L' : (shift.week_off_assigned) ? 'OFF' :
                                                shift.shift_name.split('-')[0]
                                        }}
                                    </span>
                                    <span v-if="!(shift.shift_name || shift.leave_assigned || shift.week_off_assigned)">
                                        <i class="el-icon-minus"></i>
                                    </span>
                                </span>
                            </el-popover>
                            <!-- For copy paste -->
                           <div v-else-if="isCopyPaste">
                                <el-popover
                                    v-model="shift.show_opt"
                                    placement="left-start"
                                    width="240"
                                    popper-class="ns-month-shift-dd-popover"
                                    style="max-height: 350px; overflow: auto;"
                                    trigger="manual">
                                     <template>
                                        <p class="text-sm font-semibold text-center py-2">Select Shift + Click Enter -</p>
                                        <ul class="ns-month-shift-dd" style="max-height: 350px; overflow: auto;">
                                            <li
                                            v-for="(item, iIndex) in computeShiftFieldDropDown"
                                            :id="'shift-opt-' + iIndex"
                                            :key="iIndex"
                                            class="flex items-center justify-between cursor-pointer capitalize"
                                            :class="{ focused: focusedIndex === iIndex }"
                                            @click="selectOpt(item, empIndex, shift_index, emp.id, shift)"
                                            >
                                            <span>{{ item.name }}</span>
                                            <span class="text-xs">{{ item.shift_time }}</span>
                                            </li>
                                            <li v-if="!computeShiftFieldDropDown.length" class="flex items-center justify-between">
                                                <span>No shifts found</span>
                                            </li>
                                        </ul>
                                        <template slot="reference">
                                            <input v-if="!disableForPreviousMonth && checkShiftCondition(shift.date, emp.id)" :id="'cell-' + empIndex + shift_index" :ref="shift.uId" :key="shift.uId" v-model="shift.shift_name" type="text"  tabindex="0" style="width: 100%; height: 35px;"  class="ns-ms-input"
                                                @input="searchShifts(shift.shift_name, shift.uId, empIndex, shift_index, shift)" 
                                                @paste.prevent="pasteData(empIndex, shift_index, emp.id, shift.date, shift)" @copy="copiedData(shift)" 
                                                @contextmenu.prevent="showContextMenu($event, emp.id+ '-' +shift_index, shift, empIndex, shift_index, emp.id)"
                                                @focus="setTabIndex('cell-' + empIndex + shift_index), showShiftDD(empIndex, shift_index), setShiftData(empIndex, shift_index, emp.id, shift)"
                                                @focusout="clearIfNotSelected(empIndex, shift_index, shift.shift_name)"
                                                @keydown.delete="deleteShift(empIndex, shift_index, emp.id, shift.date, shift)"
                                                @keydown.arrow-down.prevent="clickedArrowKey('down', empIndex, shift_index, emp.id, shift)"
                                                @keydown.arrow-up.prevent="clickedArrowKey('up', empIndex, shift_index, emp.id, shift)"
                                                @keydown.enter="selectOpt('from_arrow', empIndex, shift_index, emp.id, shift, 'cell-' + empIndex + shift_index)"
                                                @dblclick="showShiftDD(empIndex, shift_index)"
                                                @click="showShiftDD(empIndex, shift_index), setShiftData(empIndex, shift_index, emp.id, shift)"
                                            >
                                            <input v-else :id="'cell-' +shift.uId" :ref="shift.uId" :key="shift.uId" v-model="shift.shift_name" type="text"  tabindex="0" style="width: 100%; height: 35px; background-color: #f9f9f9;" disabled class="ns-ms-input cursor-not-allowed">
                                            <!-- @mouseenter="callOnMouseEnter(empIndex, shift_index)" -->
                                            <!-- <span v-if="shift.is_shift_dd_icon_enable" class="ns-inp-dd-icon" >
                                                <i class="el-icon-arrow-down text-lg" @click="showShiftDD(empIndex, shift_index)"></i>
                                            </span> -->
                                        </template>
                                     </template>
                                    
                                </el-popover>
                           </div>
                            <span v-else-if="!(new Date(shift.date) > new Date('2022/12/12'))" class="cursor-not-allowed">
                                <span v-if="shift.shift_name || shift.leave_assigned || shift.week_off_assigned" style="color: #dae1e7 !important"
                                    class="text-xs font-bold">
                                    {{ (shift.leave_assigned) ? 'L' : (shift.week_off_assigned) ? 'OFF' :
                                            shift.shift_name.split('-')[0]
                                    }}
                                </span>
                                <span v-if="!(shift.shift_name || shift.leave_assigned || shift.week_off_assigned)"
                                    style="color: #dae1e7 !important">
                                    <i class="el-icon-minus"></i>
                                </span>
                            </span>
                        </div>
                    </td>
                </tr>
            </table>

            <!-- If data is not available or loading -->
            <!-- <el-empty v-else-if="!newFormattedSchedulerData.length && !newFormattedSchedulerData.length" description="Something went wrong...">
                <BaseButton @click="$emit('getAllMonthData')" style="width: 110px;  margin-right:15px;" size="medium"
                    type="submit" buttonclass="btn p-2 text-xs ">
                    Retry
                </BaseButton>
            </el-empty> -->

            <div v-else-if="loading_primary_store_data" class="ns-skeleton-loading-panel">
                <el-skeleton class="scheduler-skeleton-loading" style="width: 100%" :loading="true" animated>
                    <template slot="template">
                        <el-skeleton-item class="mt-10" style="height: 320px; width: 100%;" variant="text" />
                    </template>
                </el-skeleton>
            </div>

            <div v-if="showCustomMenu" class="custom-context-menu" :style="{ top: mouseY + 'px', left: mouseX + 'px' }">
                <ul>
                    <li @click="copiedDataAtRight(), closeContextMenu">Copy <span class="font-semibold text-grey pl-3">(Ctrl + C)</span> </li>
                    <!-- <li @click="copiedData(shift), closeContextMenu">Cut</li> -->
                    <li @click="Object.values(copied_shift).length ? pasteDataAtRight(empIndex, shift_index) : '', closeContextMenu">
                        <span :class="Object.values(copied_shift).length ? '' : 'text-gray cursor-not-allowed'">Paste <span class="font-semibold text-grey pl-2">(Ctrl + V)</span></span>
                    </li>
                    <li @click="openCalenderCopy(), closeContextMenu">Bulk Shift</li>
                    <li @click="deleteShiftOnRight(), closeContextMenu">Delete</li>
                </ul>
            </div>
        </section>
        <!-- Calendar copy -->
        <el-dialog
            title="Select date range"
            :visible.sync="is_calender_copy"
            width="35%"
            custom-class="ns-dialog"
            :before-close="closeBulkShift">
                <div class="mx-auto w-full">
                    <p class="my-2 text-sm font-semibold">Select shift</p>
                    <el-select v-model="calender_copy_shift" placeholder="Select shift" filterable clearable style="width: 100% !important;" class="mb-2">
                        <el-option
                        v-for="item in computeShiftFieldDropDown"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                        </el-option>
                    </el-select>
                    <p class="my-2 text-sm font-semibold">Select date range</p>
                    <el-date-picker
                        v-model="calender_copy_date"
                        type="daterange"
                        range-separator="To"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        :picker-options="pickerOptions"
                        style="width: 100% !important;"
                    ></el-date-picker>
                </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="is_calender_copy = false, calender_copy_date = null, calender_copy_shift = null">Cancel</el-button>
                <el-button :disabled="!calender_copy_date || !calender_copy_shift" type="primary" class="ns-button" @click="applyCalenderCopy">Save</el-button>
            </span>
        </el-dialog>
        <!-- Import Schedule -->
        <el-dialog
            :title="is_import_schedule_done ? 'Schedule imported' : 'Import Schedule'"
            :visible.sync="import_schedule_popup"
            width="400px"
            :before-close="handleCloseImport"
            custom-class="ns-dialog">
            <div v-if="is_import_schedule_done">
                <img src="../../../../assets/gif/successful.gif" alt="Done" width="250px" class="block mx-auto">
                <p class="text-sm text-center mt-5">Schedule Imported Successfully</p>
            </div>
            <template v-else>
                <div v-loading="is_import_schedule_loading">
                    <el-upload
                            class="ns-upload-ms mx-auto"
                            drag
                            accept="xlsx"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :on-remove="handleRemove"
                            :on-progress="handleFileChange"
                            :on-success="handleOnImportSuccess"
                            :on-exceed="handleLimitExceed"
                            :limit="1">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                        <div slot="tip" class="el-upload__tip">XLSX files with a size less than 5mb</div>
                    </el-upload>
                    <div class="mt-6 text-center w-full">
                        <el-button :disabled="!imported_shift_data.length" type="primary" class="ns-button mx-auto" @click="proceedImportSchedule">Save</el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
        <!-- Import Schedule -->
    </div>
</template>

<script>
const $ = require("jquery");
import { EventBus } from "../../../../eventBus";
import { mapState } from "vuex";
import moment from "moment";
import LabourPlanningService from "../../../../services/labourPalnningService";
import xlsx from "json-as-xlsx";
import ExcelJS from 'exceljs';
import XLSX from 'xlsx';
export default {
 name: "MonthlySchedulePlannerTable",
 props: {
    formattedSchedulerData: {
         type: Array,
         default: () => []
     },
    shiftFieldDropDown: {
         type: Array,
         default: () => []
     },
    dayListOfMonth: {
         type: Array,
         default: () => []
     },
    monthSchedulerEmpData: {
         type: Array,
         default: () => []
     },
    searchByEmployee: {
        type: String,
        default: () => ''
    },
    selectedMonth: {
        type: Date || String,
        default: () => ''
    },
    selectedStore: {
        type: String,
        default: () => ''
    },
    isCopyPaste: {
        type: Boolean,
        default: () => true
    },
    shiftLastDate: {
        type: Object,
        default: () => {}
    },
    otherShiftData: {
        type: Array,
        default: () => []
    },
    allSecondaryStoreEmpList: {
        type: Array,
        default: () => []
    },
 },
 data() {
    return {
        selected_sId: '',
        copied_shift: {},
        items: ['First div', 'Second div', 'Third div', 'Fourth div', 'Fifth div'],
        selectedIndices: [],
        shiftKeyActive: false,
        lastSelectedIndex: null,
        showCustomMenu: false,
        mouseX: 0,
        mouseY: 0,
        shift_saved_right: {},
        emp_saved_right: {},
        selected_data: {},
        right_click_empIndex: '',
        right_click_shiftIndex: '',
        enable_multi_select: false,
        multiple_selections: [],
        focusDivData: {},   
        UIdCounter: 0,
        shiftSearch: '',
        is_calender_copy: false,
        calender_copy_date: null,
        calender_copy_shift: null,
        focusedInputIndex: null,
        monthly_shift_data: [],
        formatted_monthly_scheduler_data: [],
        isChangesOccurred: false,
        focusedIndex: 0,
        selected_opt_data: {},
        import_schedule_popup: false,
        imported_shift_data: [],
        is_import_schedule_loading: false,
        is_import_schedule_done: false,
        loading_primary_store_data: false,
        leave_types: [],
    }
 },
 computed: {
    ...mapState("MonthlySchedulerStore", ["copied_shift_data"]),
    searchByEmp(){
        return this.searchByEmployee;
    },
    disableForPreviousMonth(){
        return moment(this.selectedMonth).format('YYYY-MM') < moment().format('YYYY-MM');
    },
    newFormattedSchedulerData() {
        let result = JSON.parse(JSON.stringify(this.formatted_monthly_scheduler_data)); // Create a deep copy

        // result.forEach((e, empIndex) => {
        //     const initialTimestamp = new Date().getTime() + empIndex * 1000; // Add a delay of 1 second per employee

        //     e.all_shift_data.forEach((r, index) => {
        //         const timestamp = initialTimestamp + index * 1000; // Add a delay of 1 second
        //         r.uId = e.id + r.date;
        //     });
        // });

        if (this.searchByEmployee) {
            result = result.filter((item) => {
                return this.searchByEmployee.toLowerCase().split(' ').every(v => item.full_name.toLowerCase().includes(v))
            });
        } else {
            result = result;
        }

        return result;
    },
    computeShiftFieldDropDown(){
        let result = [...this.shiftFieldDropDown];
        let leaves = this.leave_types.map((e)=> {
            return {
                id: e.id,
                name: e.leave_type,
                shift_time: '',
                is_leave: true
            }
        });
        // if have leave types
        if(leaves.length){
            result = [...result, ...leaves];
        }
        if(this.shiftSearch){
            result = result.filter((e)=> e.name.toLowerCase().match(this.shiftSearch.toLowerCase()));
            this.focusedIndex = 0;
            result.length ? result[0].is_selected = true : '';
        }
        return result;
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
            const currentDate = new Date(time);
            const selectedMonthDate = new Date(this.selectedMonth);
            // Disable dates outside the selected month
            return currentDate.getMonth() !== selectedMonthDate.getMonth() ||
                currentDate.getFullYear() !== selectedMonthDate.getFullYear();
        },
      };
    },
 },
 created() {
    // this.getLeaveTypes();
 },
 mounted() {
    const self = this;
    EventBus.$on('clearShiftId', (action)=> {
        if(action){
            this.selected_sId = '';
        }
    });
    EventBus.$on('generateExcelTemplate', ()=> {
        this.generateExcelTemplate();
    });
    EventBus.$on('importSchedule', (value)=> {
        this.import_schedule_popup = value;
    });
    EventBus.$on('updatePrimaryStoreData', (value)=> {
        this.getShiftData();
        this.updateAssignmentData();
    });
    document.addEventListener('click', this.closeContextMenu);
    // Get shift data 
    this.getShiftData();
    window.addEventListener('click', this.closeOutsideClick);
 },
 beforeDestroy() {
    EventBus.$off("clearShiftId");
    EventBus.$off("updatePrimaryStoreData");
    EventBus.$off("generateExcelTemplate");
    EventBus.$off("importSchedule");
    document.removeEventListener('click', this.closeContextMenu); 
    window.removeEventListener('click', this.closeOutsideClick);
 },
 methods: {
    deleteShiftByEmp(empId){
        console.log(empId, 'empId');
        let payload = {
            outlet_id: this.selectedStore,
            employee_id: empId,
            from_date: moment().format('YYYY-MM-DD'),
            to_date: this.shiftLastDate.formatDate
        }
        // Check moment().format('YYYY-MM-DD') data is from selected month or not
        if(moment().format('YYYY-MM') !== moment(this.selectedMonth).format('YYYY-MM')){
            payload.from_date = moment(this.selectedMonth).startOf('month').format('YYYY-MM-DD');
            payload.to_date = moment(this.selectedMonth).endOf('month').format('YYYY-MM-DD');
        }

        this.$confirm('Are you sure you want to delete this employee shift?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
        }).then(() => {
            LabourPlanningService.deleteSiftByEmp(payload).then((res) => {
                this.isChangesOccurred = true;
                this.getShiftData();
                this.updateAssignmentData();
                this.$emit('UpdateSSShifts', true);
            }).catch((err) => {
                console.error(err);
            });
        }).catch(() => {
            this.$message({
                type: 'info',
                message: 'Delete cancelled'
            });  
        });
    },
    setShiftData(empIndex, shift_index, empId, shift){
        this.selected_opt_data = {empIndex, shift_index, empId, shift};
    },
    async getLeaveTypes(empIndex, shift_index, empId, shift){
        await LabourPlanningService.getLeaveType().then((res)=>{
            let leaveTypes = JSON.parse(res.data);
            this.leave_types = leaveTypes;
            this.$forceUpdate();
        }).catch((err)=>{
            console.error(err);
        });
    },
    clearIfNotSelected(empIndex, shiftIndex, shift_name){
        if(shift_name){
            if(!this.shiftFieldDropDown.filter((e)=> e.name === shift_name).length && shift_name !== 'OFF' && shift_name !== 'L' && !this.leave_types.find((e)=> e.initials === shift_name)){
                this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = '';
            }
            this.$forceUpdate();
        }
    },
    checkShiftCondition(shiftDate, empId){
        let result = true;

        if(!this.allSecondaryStoreEmpList.includes(empId)){
            result = true;
            return result;
        }
        // Check for secondary stores
        this.otherShiftData.find((e)=> {
            if(e.employee === empId && e.date === shiftDate && e.store_id != this.selectedStore ){
                result = false;
            }
        });
        
        return result;
    },
    clearIfNotdeleteShiftByEmpSelected(empIndex, shiftIndex, shift_name){
        if(shift_name){
            if(!this.shiftFieldDropDown.filter((e)=> e.name === shift_name).length && shift_name !== 'OFF') {
                this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = '';
            }
            this.$forceUpdate();
        }
    },
    clickedArrowKey(direction, empIndex, shift_index, empId, shift){
        const optIndex = this.computeShiftFieldDropDown.length;
        if (optIndex) {
            if (direction === 'down') {
                this.focusedIndex = Math.min(this.focusedIndex + 1, optIndex - 1);
            } else if (direction === 'up') {
                this.focusedIndex = Math.max(this.focusedIndex - 1, 0);
            }
            document.getElementById('shift-opt-' + this.focusedIndex).focus();
            // console.log( document.getElementById('shift-opt-' + this.focusedIndex), 'focsed element')
            this.selected_opt_data = {empIndex, shift_index, empId, shift};
            // Set the selected index and update value
            this.computeShiftFieldDropDown.map((e, index)=>{
                if(this.focusedIndex === index) {
                    e.is_selected = true;
                } else {
                    e.is_selected = false;
                }
            });
        }
    },
    saveShift(empId, shift, selected_sId, type) {
        console.log(shift,selected_sId, 'shift')
        let payload = [
            {
                store_id: this.selectedStore,
                employee: empId,
                date: shift.date
            }
        ];
        // If clear shift
        if (type == 'clear_shift') {
            this.clearShiftOfEmp(empId, shift.date)
        } else if (type == 'leave') {
            payload[0].leave_assigned = true;
            payload[0].week_off_assigned = false;
            payload[0].assigned_shift = null;
            selected_sId ? payload[0].leave_type = selected_sId : '';
            this.saveShiftDataOfEmp(payload);
        } else if (type == 'shift') {
            payload[0].leave_assigned = false;
            payload[0].week_off_assigned = false;
            payload[0].assigned_shift = selected_sId;
            this.saveShiftDataOfEmp(payload);
        } else if (type == 'off') {
            payload[0].leave_assigned = false;
            payload[0].week_off_assigned = true;
            payload[0].assigned_shift = null;
            this.saveShiftDataOfEmp(payload);
        }
    },
    saveShiftDataOfEmp(payload) {
        LabourPlanningService.saveAllMonthlyShiftsData(payload).then((res) => {
            this.isChangesOccurred = true;
            this.getShiftData();
            this.updateAssignmentData();
            console.log('UpdateSSShifts')
            this.$emit('UpdateSSShifts', true);
        }).catch((err) => {
            console.error(err);
        }).finally(() => {
            this.selected_sId = '';
            // EventBus.$emit('clearShiftId', true);
        });
    },
    saveShiftDataOfEmpImported(payload) {
        this.is_import_schedule_loading = true;
        LabourPlanningService.saveAllMonthlyShiftsData(payload).then((res) => {
            this.isChangesOccurred = true;
            this.is_import_schedule_loading = false;
            this.is_import_schedule_done = true;
            this.getShiftData();
            this.updateAssignmentData();
        }).catch((err) => {
            console.error(err);
            this.is_import_schedule_loading = false;
        }).finally(() => {
            this.selected_sId = '';
        });
    },
    updateAssignmentData(){
        let from_date = moment(this.selectedMonth).startOf('month').format('YYYY-MM-DD');
        let to_date = moment(this.selectedMonth).endOf('month').format('YYYY-MM-DD');
        let getEmpPayload = { outlet_id: this.selectedStore, start_date: from_date, end_date: to_date, get_all: true };
        LabourPlanningService.getAllMonthlyShiftWiseAss(getEmpPayload).then((res)=>{
            let getShiftWiseAssData = JSON.parse(res.data);
            this.$store.commit("MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_ASS_DATA", getShiftWiseAssData);
            this.$emit('formattingShiftAsgData');
        }).catch((err)=>{
            // this.$notify.error({
            //     title: 'Error',
            //     message: 'Something went wrong!'
            // });
            console.error(err);
        })
    },
    async getShiftData(){
        this.loading_primary_store_data = true;
        let from_date = moment(this.selectedMonth).startOf('month').format('YYYY-MM-DD');
        let to_date = moment(this.selectedMonth).endOf('month').format('YYYY-MM-DD');
        let getEmpPayload = { outlet_id: this.selectedStore, start_date: from_date, end_date: to_date, get_all: true };
        // await this.getLeaveTypes();
        LabourPlanningService.getLeaveType().then((res)=>{
            let leaveTypes = JSON.parse(res.data);
            this.leave_types = leaveTypes;
            this.$forceUpdate();
        }).catch((err)=>{
            console.error(err);
        }).finally(()=>{
            LabourPlanningService.getAllMonthlyShiftsData(getEmpPayload).then((res)=>{
                let getShiftData = JSON.parse(res.data);
                this.monthly_shift_data = getShiftData;
                this.$emit('updatedSchData', getShiftData);
                // this.$store.commit("MonthlySchedulerStore/SET_MONTH_SCHEDULER_SHIFT_DATA", getShiftData);
            }).catch((err)=>{
                console.error(err);
            }).finally(()=>{
                this.formatScheduleData();
            })
        })
    },
    formatScheduleData(){
        console.log(this.monthly_shift_data, 'updated shift data');
        let result = [];

        // Create deep copies of necessary data
        const days = JSON.parse(JSON.stringify(this.dayListOfMonth));
        const empData = [...this.monthSchedulerEmpData];
        const shifts = JSON.parse(JSON.stringify(this.monthly_shift_data));
        const sData = JSON.parse(JSON.stringify(this.shiftFieldDropDown));

        // Add necessary keys to each day
        days.forEach((dd) => {
            dd.against_deficit = null;
            dd.against_shift = null;
            dd.is_excess = null;
            dd.week_off_assigned = null;
            dd.date = dd.formatDate;
        });

        // Format and merge employee data with shifts and days
        result = JSON.parse(JSON.stringify(empData));
        result.forEach(emp => {
            emp.shift_data = shifts.filter((sd) => sd.employee == emp.id);
            let allShifts = _.unionBy(emp.shift_data, days, 'date');
            emp.all_shift_data = _.sortBy(allShifts, ['date']);
        });

        // Set shift names
        result.forEach((r) => {
            r.all_shift_data.forEach((s) => {
                if (s.assigned_shift) {
                    const shiftNameData = sData.find((sd) => sd.id == s.assigned_shift);
                    s.shift_name = shiftNameData ? shiftNameData.name : '-';
                    s.toggle_dropdown = false;
                } else if(s.week_off_assigned) {
                    s.shift_name = 'OFF';
                } else if(s.leave_assigned) {
                    s.shift_name = s.leave_type ? this.getLeaveType(s.leave_type) : 'L';
                    console.log(s.leave_type,this.getLeaveType(s.leave_type), 's.leave_type')
                }
            });
        });
        if(this.focusedInputIndex){
            document.getElementById(this.focusedInputIndex).focus();
        }
        // Store the formatted result in the component data property
        this.formatted_monthly_scheduler_data = result;

        // Return the formatted result
        // return result;
        this.$forceUpdate();
        this.loading_primary_store_data = false;
    },
    getLeaveType(id){
        let leaveType = this.leave_types.find((e)=> e.id === id);
        return leaveType ? leaveType.initials : '';
    },
    deleteShift(empIndex, shift_index, empId, shiftDate, shift){
        if(this.shiftFieldDropDown.find((s)=> s.name === shift.shift_name) || shift.shift_name === 'OFF' || shift.leave_assigned){
            if(empId && shift.date) {
                this.clearShiftOfEmp(empId, shift.date);
            }
        }
        console.log(shift.shift_name, shift, 'Delete shift');
    },
    clearShiftOfEmp(empId, date) {
        let payload = { employee_id: empId, date: date, outlet_id: this.selectedStore }
        LabourPlanningService.clearEmployeeShift(payload).then((res) => {
            this.isChangesOccurred = true;
            this.$message({
                message: 'Shift deleted successfully',
                type: 'success'
            });
            this.$emit('UpdateSSShifts', true);
            this.getShiftData();
            this.updateAssignmentData();
        }).catch((err) => {
            console.error(err)
        }).finally(() => {
            this.selected_sId = '';
        });
    },
    applyCalenderCopy(){
        let allDates = this.getDatesInRange(this.calender_copy_date[0], this.calender_copy_date[1]);
        let empId = '';
        this.newFormattedSchedulerData.map((e)=>{
            if(e.id === this.emp_saved_right) {
                empId = e.id;
                e.all_shift_data.map((s)=>{
                    if(moment(s.date) >= moment(this.calender_copy_date[0]) && moment(s.date) <= moment(this.calender_copy_date[1])) {
                        s.shift_name = this.calender_copy_shift;
                        console.log(s.id, 's.id')
                    }
                });
            }
        });
        // Update changes for all
        if(allDates.length && empId){
            let shiftData = this.computeShiftFieldDropDown.find((s)=> s.name === this.calender_copy_shift);
            let payload = [];
            for (let i of allDates) {
                let obj = {
                    store_id: this.selectedStore,
                    employee: empId,
                    date: i,
                    leave_assigned: shiftData.name === 'Leave' || shiftData.is_leave ? true : false,
                    leave_type: shiftData.is_leave ? shiftData.id : null,
                    week_off_assigned: shiftData.name === 'Week Off',
                    assigned_shift: (shiftData.name !== 'Leave' && shiftData.name !== 'Week Off' && !shiftData.is_leave) ? shiftData.id : '',
                }
                payload.push(obj);
            }
            this.saveShiftDataOfEmp(payload);
        }
        this.is_calender_copy = false;
    },
    getDatesInRange(startDate, endDate) {
        const dates = [];
        const currentDate = moment(startDate);
        const lastDate = moment(endDate);

        while (currentDate.isSameOrBefore(lastDate)) {
            dates.push(currentDate.format('YYYY-MM-DD'));
            currentDate.add(1, 'days');
        }

        return dates;
    },
    openCalenderCopy(){
        this.is_calender_copy = !this.is_calender_copy;
    },
    searchShifts(name, id, empIndex, shiftIndex, shift) {
        this.shiftSearch = name;
        this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].show_opt = true;
        this.newFormattedSchedulerData.map((e, eIndex)=>{
            e.all_shift_data.map((s, sIndex)=>{
                if(!(eIndex === empIndex && sIndex === shiftIndex)){
                    s.show_opt = false;
                }
            })
        });
        this.$forceUpdate();
        // this.shiftFieldDropDown = this.shiftFieldDropDown.filter((e)=> e.name.toLowerCase().match(name.toLowerCase()));
    },
    selectOpt(elm,empIndex,shiftIndex, empId, shift, idName) {
        // Select index
        if(elm === 'from_arrow'){
            let selElm = this.computeShiftFieldDropDown.find((e)=> e.is_selected);
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = selElm.name;
            elm = selElm;
            this.computeShiftFieldDropDown.map((e, index)=>{
                e.is_selected = false;
            });
            this.focusedIndex = -1;
            // Press tab key
            this.simulateTabKeyPress(idName);
        }
        // Check for weekly off and off
        if(elm.id === 'OFF'){
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = 'OFF';
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].week_off_assigned = true;
            this.saveShift(empId, shift, null, 'off');
        } else if(elm.id === 'LEAVE') {
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = 'L';
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].leave_assigned = true;
            this.saveShift(empId, shift, null, 'leave');
        } else if(elm.is_leave){
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = elm.name;
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].leave_assigned = true;
            this.saveShift(empId, shift, elm.id, 'leave');
        } else {
            this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].shift_name = elm.name;
            this.saveShift(empId, shift, elm.id, 'shift');
        }
        this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].show_opt = false;
        this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].is_shift_dd_icon_enable = false;
        this.$forceUpdate();
    },
    simulateTabKeyPress(idName) {
        const tabKeyEvent = new KeyboardEvent('keydown', {
            key: 'Tab',
            code: 'Tab',
            keyCode: 9,
            which: 9,
            shiftKey: false,
            bubbles: true,
        });

        // Replace this line with the actual element you want to simulate the Tab key press on
        const targetElement = document.getElementById(idName);

        if (targetElement) {
            targetElement.dispatchEvent(tabKeyEvent);
        }
        console.log('Well', targetElement)
    },
    generateUniqueId(timestamp) {
        const uniqueNumber = timestamp % 900000 + 100000; // Ensure 6 digits
        return uniqueNumber;
    },
    handleSelect(item) {
        console.log(item);
    },
    selectElmOnFocus(item) {
        console.log('selected focused');
    },
    showShiftOpt(shift, event){
        shift.show_opt = true;
        console.log(event, 'typing')
    },
    togglePopover(){
        $('.el-popover').hide();
        // this.selected_sId = '';
    },
    copiedData(shift){
        if(!(shift.shift_name || shift.leave_assigned || shift.week_off_assigned)){
            this.$message({
                message: 'Empty shift not allowed',
                type: 'error'
            });
            return;
        }
        this.copied_shift = shift;
        this.copied_shift = shift;
        console.log(shift, 'copied data')
        this.$message("Copied Successfully");
    },
    pasteData(emp_index, shift_index, empId, shiftDate, shift){
        // Prepare for rendering
        // Check leave and weekoff
        let renderData = {
            week_off_assigned: false,
            leave_assigned: false,
            date: shiftDate,
            employee: empId,
            manually_assigned:true
        }
        if(this.copied_shift.week_off_assigned){
            renderData.week_off_assigned = true;
            renderData.shift_name = 'OFF';
            this.saveShift(empId, shift, null, 'off');
        } else if(this.copied_shift.leave_type){
            let shiftData = this.computeShiftFieldDropDown.find((s)=> s.id === this.copied_shift.leave_type); 
            renderData.shift_name = shiftData.name;
            renderData.leave_assigned = true;
            console.log(this.copied_shift.leave_type, 'this.copied_shift.leave_type')
            this.saveShift(empId, shift, this.copied_shift.leave_type, 'leave');
        } else if(this.copied_shift.leave_assigned){
            renderData.leave_assigned = true;
            renderData.shift_name = 'L';
            this.saveShift(empId, shift, null, 'leave');
            console.log(this.copied_shift.leave_type, 'this.copied_shift.leave_type')
        } else {
            let shiftData = this.shiftFieldDropDown.find((s)=> s.name === this.copied_shift.shift_name);
            renderData.shift_name = shiftData.name;
            renderData.assigned_shift = shiftData.id;
            this.saveShift(empId, shift, shiftData.id, 'shift');
        }
        // Check multi select first
        if(this.enable_multi_select) {
            for (const e of this.multiple_selections) {
                this.newFormattedSchedulerData[e.empIndex].all_shift_data[e.shiftIndex] =  renderData;
            }
        } else {
            this.newFormattedSchedulerData[emp_index].all_shift_data[shift_index] =  renderData;
        }
        
        this.$message({
          message: 'Paste Successfully',
          type: 'success'
        });
        let shiftData = this.shiftFieldDropDown.find((s)=> s.name === this.copied_shift.shift_name);
        this.$forceUpdate();
    },
    showContextMenu(event, ref, shift, empIndex, shift_index, empId) {
        this.shift_saved_right = shift;
        if(Object.keys(shift).length){
            this.calender_copy_shift = shift.week_off_assigned ? 'Week Off' : shift.leave_assigned ? 'Leave' : shift.shift_name;
        }
        this.emp_saved_right = empId;
        this.right_click_empIndex = empIndex;
        this.right_click_shiftIndex = shift_index;
        event.preventDefault(); // Prevent the default context menu from showing up
        this.showCustomMenu = true;
        this.mouseX = event.pageX - 90;
        this.mouseY = event.pageY - 90;
        this.closeAllShiftDD();

        // for (let iterator in this.$refs) {
        //     if(iterator === ref){
        //         this.$refs[iterator][0].style.backgroundColor = '#ffe6d2';
        //         this.$refs[iterator][0].style.borderWidth = '2px';
        //     } else if(!this.enable_multi_select) {
        //         this.$refs[iterator][0].style.backgroundColor = '';
        //         this.$refs[iterator][0].style.borderWidth = '1px';
        //     }
        // }
    },
    copiedDataAtRight(){
        this.copied_shift = this.shift_saved_right;
        this.$message("Copied Successfully");
    },
    pasteDataAtRight(){
        this.newFormattedSchedulerData[this.right_click_empIndex].all_shift_data[this.right_click_shiftIndex] =  this.copied_shift;
        this.$message({
          message: 'Paste Successfully',
          type: 'success'
        });
        if(this.selected_opt_data.empId) {
            this.pasteData(this.selected_opt_data.empIndex, this.selected_opt_data.shift_index, this.selected_opt_data.empId, this.selected_opt_data.shift.date, this.selected_opt_data.shift);
        }
        this.$forceUpdate();
    },
    closeContextMenu() {
        this.showCustomMenu = false; // Close the custom context menu
        // this.newFormattedSchedulerData.map((e, eIndex)=>{
        //     e.all_shift_data.map((s, sIndex)=>{
        //         s.show_opt = false;
        //     })
        // });
        this.$forceUpdate();
    },
    closeOutsideClick(e) {
        if (!document.getElementById('month-schedule-table').contains(e.target)){
            this.closeAllShiftDD();
        }
    },
    closeAllShiftDD() {
        this.newFormattedSchedulerData.map((e, eIndex)=>{
            e.all_shift_data.map((s, sIndex)=>{
                s.show_opt = false;
            })
        });
        this.$forceUpdate();
    },
    setTabIndex(data){
        this.focusedInputIndex = data;
        this.shiftSearch = '';
    },
    showShiftDD(empIndex, shiftIndex){
        console.log('clicked', empIndex, shiftIndex)
        this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].show_opt = true;
        this.newFormattedSchedulerData.map((e, eIndex)=>{
            e.all_shift_data.map((s, sIndex)=>{
                if(!(eIndex === empIndex && sIndex === shiftIndex)){
                    s.show_opt = false;
                }
            })
        });
        this.$forceUpdate();
        EventBus.$emit('closeSS_DD', true);
        console.log(this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].show_opt)
    },
    callOnMouseEnter(empIndex, shiftIndex){
        this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].is_shift_dd_icon_enable = true;
        this.newFormattedSchedulerData.map((e, eIndex)=>{
            e.all_shift_data.map((s, sIndex)=>{
                if(!(eIndex === empIndex && sIndex === shiftIndex)){
                    s.is_shift_dd_icon_enable = false;
                }
            })
        });
        this.$forceUpdate();
    },
    hideShiftDD(empIndex, shiftIndex){
        this.newFormattedSchedulerData[empIndex].all_shift_data[shiftIndex].show_opt = false;
        this.$forceUpdate();
    },
    handleRemove(){

    },
    deleteShiftOnRight(){
        if(this.emp_saved_right && Object.keys(this.shift_saved_right).length) {
            this.shift_saved_right.date ? this.clearShiftOfEmp(this.emp_saved_right, this.shift_saved_right.date) : '';
        }
    },
    closeBulkShift(){
        this.is_calender_copy = false;
        this.calender_copy_date = null;
        this.calender_copy_shift = null;
    },
    generateExcelTemplate() {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Schedule');
        const all_month_dates = [];
        let dropdownOptions = [];

        for (const i of this.dayListOfMonth) {
            all_month_dates.push(i.formatDate);
        }
        for (const i of this.shiftFieldDropDown) {
            dropdownOptions.push(i.name);
        }
        // console.log(['"' + dropdownOptions.join(',') + '"'], 'dropdownOptions')
        // Write headers
        worksheet.addRow(['Name', 'Employee ID', 'Designation', ...all_month_dates]);

        // Write data and apply data validation
        this.monthSchedulerEmpData.forEach((item, rowIndex) => {
            const rowData = [item.full_name, item.id, item.designation_info.name, ...all_month_dates.map(date => item[date])];
            const row = worksheet.addRow(rowData);

            // Apply data validation to dropdown cells
            all_month_dates.forEach((date, columnIndex) => {
            const cell = row.getCell(columnIndex + 4); // +4 to account for 'Name' and 'ID' columns

            const validationValues = {
                type: 'list',
                formulae: ['"' + dropdownOptions.join(',') + '"'],
                // formulae: ['"One,Two,Three,Four"'],
                showDropDown: true
            };

            cell.dataValidation = validationValues;
            });
        });

        // Generate Excel file
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'excel-export.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    },
    async handleFileChange(event,file) {
        try {
            // const file = event.target.files[0];
            file = file.raw
            console.log(event, file, 'details')
        // Check file type first
        if(file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
            if (file) {
                this.imported_shift_data = [];
                const workbook = new ExcelJS.Workbook();
                await workbook.xlsx.load(file);
                this.imported_shift_data = this.workbookToJson(workbook);
            }
        } else {
            this.$notify.warning({
                title: "Oops! 🙁",
                message: "Only xlsx file allowed.",
                duration: 3000, // Duration in milliseconds (3 seconds in this case)
            });
        }
      } catch (error) {
        console.error('Error reading file:', error);
      }
    },
    workbookToJson(workbook) {
      let sheetAllData = [];
      workbook.eachSheet((worksheet) => {
        let nameColumnIndex = 1;
        let idColumnIndex = 1;
        let sheet_data = [];
        worksheet.eachRow((row, rowIndex) => {
            row.eachCell((cell, columnIndex) => {
                // console.log(cell, 'cell data');
                // console.log(row, 'row data');
                if (cell.value === 'Name') {
                    nameColumnIndex = columnIndex;
                }
                if (cell.value === 'Employee ID') {
                    idColumnIndex = columnIndex;
                }
            });
            // return;
          if (rowIndex === 1) {
            // Identify the index of 'Name' and 'ID' columns
            row.eachCell((cell, columnIndex) => {
              if (cell.value === 'Name') {
                nameColumnIndex = columnIndex;
              }
              if (cell.value === 'Employee ID') {
                idColumnIndex = columnIndex;
              }
            });
          } else if (rowIndex >= 1) {
            // Process data rows
            const obj = {
                name: '',
                id: '',
                data: []
            };
            const name = row.getCell(nameColumnIndex).value;
            const id = row.getCell(idColumnIndex).value;
            obj.name = name;
            obj.id = id;
            sheetAllData.push(obj);

            const dateShiftPairs = [];
            row.eachCell((cell, columnIndex) => {
              if (columnIndex >= 4 && cell.value) {
                sheet_data.push({shift: cell.value, cell})
                const dateIndex = columnIndex - 2;
                dateShiftPairs.push({ [`${dateIndex} - ${cell.type}`]: cell.value });
              }
            });
          }
        });
        // Prepare all cell data
        sheetAllData.map((s)=>{
            sheet_data.forEach(e => {
                if(e.cell._row.values[2] === s.id) {
                    s.data.push({ date: e.cell._column.values[1], shift: e.shift, shift_id: e.shift ? this.shiftFieldDropDown.find((l) => l.name === e.shift).id : ''  })
                }
            });
        });
      });
      return sheetAllData;
    },
    proceedImportSchedule(){
        // Prepare payload
        let payload = [];
        for (let i of this.imported_shift_data) {
            for (const j of i.data) {
                payload.push({
                    store_id: this.selectedStore,
                    employee: i.id,
                    date: j.date,
                    leave_assigned: j.shift_id === 'OFF',
                    week_off_assigned: j.shift_id === 'LEAVE',
                    assigned_shift: (j.shift_id !== 'LEAVE' &&  j.shift_id !== 'OFF') ? j.shift_id : '',
                });
            }
        }
        console.log(payload, 'payload')
        this.saveShiftDataOfEmpImported(payload);
    },
    handleCloseImport(){
        this.is_import_schedule_done = false;
        this.import_schedule_popup = false;
    },
    handleOnImportSuccess(){
        // this.$notify.success({
        //     name: "Success",
        //     message: "Schedule imported successfully"
        // })
    },
    handleLimitExceed(){
        this.$notify.warning({
          title: "Oops! 🙁",
          message: "Only one file is allowed.",
          duration: 3000, // Duration in milliseconds (3 seconds in this case)
        });
    }
 },
}
</script>

<style>
/* Style to fit the page horizontally */
@media print {
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  #month-schedule-table {
    width: 100%;
  }
}
.el-popover {
    min-width: auto !important;
}
/* Style the selected text inside the .shift-data-cell element */
    .ns-badge .el-badge__content{
        background-color: #e29d5a !important;
    }
    .ns-ms-tb-icon{
        top: -14px;
        right: -23px;
        font-size: 22px;
    }
.ns-month-dd-popov .el-popover{
    width: 85px !important;
}
.ns-month-shift-dd-popover{
    /* position: fixed !important; */
}


.ns-dialog .el-dialog__header {
    background: #fdfdfd;
    color: #1c1b1b;
    padding: 25px 20px;
    border-radius: 8px;
}

.ns-dialog.el-dialog {
    border-radius: 8px;
}

.ns-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #1c1b1b;
    font-weight: 700;
}

.ns-dialog .el-dialog__footer {
    /* position: fixed; */
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
    border-radius: 8px;
}
.ns-dialog .el-dialog__body {
    padding: 5px 20px 30px 20px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.ns-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-weight: 600;
    font-size: 25px;
}
.ns-upload-ms {
    width: fit-content;
}
.ns-upload-ms .el-upload-dragger{
    /* padding: 5px 15px; */
    /* width: auto !important; */
}
</style>

<style lang="scss">
    @import './MonthlyScheduler.scss';
.custom-context-menu {
    position: absolute;
    padding: 12px;
    border: 1px solid #d7d7d7;
    border-radius: 4px;
    font-size: 14px;
    background: white;
    z-index: 15;
    text-align: left;
    // box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.custom-context-menu ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.custom-context-menu li {
  cursor: pointer;
  padding: 7px 18px;
}

.custom-context-menu li:hover {
  background-color: #f0f0f0;
}
.ns-month-shift-dd{
    list-style: none;
    padding-left: 0;
    li{
        padding: 8px 10px; 
    }
    li:hover{
        color: #e29d5a;
     }  
}
.month-td-right{
    position: relative;
}
.ns-month-shift-calender{
    position: absolute;
    top: -1px;
    right: -1px;
    cursor:pointer;
}
.ns-ms-input{
    @media only screen and (max-width: 1400px) {
        font-size: 9px;
    }
    // @media only screen and (max-width: 1150px) {
    //     font-size: 9px;
    // }
    font-size: 12px;
    text-align: center;
    text-transform: capitalize;
}
.focused {
    color: #e29d5a;
    // border: 1px solid #e29d5a;
}
.ns-month-shift-dd{
    // max-height: 250px;
    // overflow-y: scroll;
}
.ns-inp-dd-icon{
    position: absolute;
    right: -15px;
    top: 11px;
    z-index: 2;
    background: white;
    border: 1px solid #d7d7d7;
    padding: 0 2px;
    text-align: center;
}
</style>